import { useContext, useEffect } from 'react';
import { UserContext } from '@auth0/nextjs-auth0/client';
import { runInAction } from 'mobx';
import { useAuthStore } from '../hooks/useAuthStore';

export const AuthStoreSync = () => {
    const authStore = useAuthStore();
    const auth0 = useContext<UserContext>(UserContext);
    const { isLoading, error, user } = auth0;

    useEffect(() => {
        if (!authStore.auth0 && auth0) {
            runInAction(() => (authStore.auth0 = auth0));
        }
    }, [authStore, authStore.auth0, auth0]);

    useEffect(() => {
        if (error !== undefined && authStore.auth0?.error?.message !== error?.message) {
            runInAction(() => {
                if (authStore.auth0) {
                    authStore.auth0.error = error;
                }
            });
        }
    }, [authStore, error]);

    useEffect(() => {
        if ((user?.sub || user?.userId) && authStore.auth0?.user?.userId !== user?.userId) {
            runInAction(() => {
                authStore.user = user;
                if (authStore.auth0) {
                    authStore.auth0.user = user;
                    authStore.auth0.isLoading = isLoading;
                }
            });
        }
    }, [authStore, user, isLoading]);

    useEffect(() => {
        if (isLoading !== undefined && authStore.auth0?.isLoading !== isLoading) {
            runInAction(() => {
                if (authStore.auth0) {
                    authStore.auth0.isLoading = isLoading;
                }
            });
        }
    }, [authStore, isLoading]);

    return null;
};
